import { AppState } from '../store/store';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { TwoFactorLoginFormValues } from './TwoFactorLogin';
import { FormikHelpers } from 'formik';
import { loginWith2fa, postSuccessfulLogin } from './authActions';
import { parseErrorMessage } from '../common/errors/helpers';
import { InternalNavigation } from '../navigation/helper';

export function useSubmitTwoFactorLoginForm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const mfaToken = useSelector((state: AppState) => state.auth.mfaToken);

  const submitTwoFactorLoginForm = useCallback(
    async (values: TwoFactorLoginFormValues, { setStatus, setSubmitting }: FormikHelpers<TwoFactorLoginFormValues>) => {
      try {
        const accessToken = await loginWith2fa(values.otp, mfaToken);

        if (accessToken.error || accessToken.errorDescription) {
          if (accessToken.error === 'invalid-mfa-code') {
            setStatus('Invalid code');
          } else {
            setStatus(accessToken.errorDescription ? accessToken.errorDescription : accessToken.error);
          }
          return;
        }
        await postSuccessfulLogin(dispatch, accessToken, location);
        navigate(InternalNavigation.root, { state: location.state, replace: true });
      } catch (e: any) {
        setStatus(await parseErrorMessage(e));
      } finally {
        setSubmitting(false);
      }
    },
    []
  );

  return { submitTwoFactorLoginForm };
}
